import {
  DatePicker,
  Icon,
  SearchBar,
  SearchDataProps,
  Section,
  useToast,
} from '@vallourec-ui/vallourec-ui'
import React, { useEffect, useRef } from 'react'

import { useTranslation } from 'react-i18next'

import moment from 'moment'

import { isAxiosError } from 'axios'

import { useLocation } from 'react-router-dom'

import { useGenerateReport } from '@/stores/GenerateReportStore'

import {
  ButtonContainer,
  ExpandedOptionsWrapper,
  Row,
  SearchBarContainer,
  StyledButton,
  StyledInputLabel,
  StyledTextButton,
} from './style'
import { SITES, TESTS } from '@/utils/constants'

import { InsterpectorTypeEnum, SampleTypeEnum } from '@/@types/enums'
import { DataResultTemplate, OrderItemFilter } from '@/@types/global'
import { documentSearch, reportFilter } from '@/api/post'
import TextFieldInput from '@/components/TextFieldInput'
import { generateObject } from '@/report/generateTest'
import { useApp } from '@/stores/AppStore'
import { addOptionAll } from '@/utils/utils'

const FilterSection: React.FC = () => {
  const { t } = useTranslation()
  const { toast } = useToast()
  const location = useLocation()
  const dataState = location.state
  const originApprovalFlow = dataState?.docCode

  const rowFocus = useRef<HTMLInputElement>(null)
  const {
    setIsLoading,
    setTemplateColumn,
    setTemplateRow,
    setResultItems,
    executeSearch,
    setExecuteSearch,
    startDateApprovalFlow,
    setStartDateApprovalFlow,
    endDateApprovalFlow,
    setEndDateApprovalFlow,
    processOrderItemsApprovalFlow,
    setProcessOrderItemsApprovalFlow,
    pqLotItemsApprovalFlow,
    setPqLotItemsApprovalFlow,
    user,
  } = useApp()
  const {
    site,
    setSite,
    test,
    setTest,
    mappedSites,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    project,
    setProject,
    orderItem,
    setOrderItem,
    typeInspection,
    setTypeInspection,
    type,
    setType,
    testSelected,
    setTestSelected,
    heatItems,
    setHeatItems,
    processOrderItems,
    setProcessOrderItems,
    pqLotItems,
    setPqLotItems,
    setTemplateTest,
    identificationApprovalFlow,
    setIdentificationApprovalFlow,
    clientHeader,
    setClientHeader,
    setDescriptionHeader,
    setProjectHeader,
    setInspectionHeader,
    setPedidoItemHeader,
    setRemark1,
    setRemark2,
    setRemark3,
  } = useGenerateReport()

  const [orderItemFilter, setOrderItemFilter] =
    React.useState<OrderItemFilter>()
  const [labelProject, setLabelProject] = React.useState('')
  const [mappedTestsFilter, setMappedTestsFilter] = React.useState<
    SearchDataProps[]
  >([])
  const [siteCode, setSiteCode] = React.useState<string>('')
  const [mapPqLot, setMapPqLot] = React.useState<SearchDataProps[]>([])
  const [mapProcessOrder, setMapProcessOrder] = React.useState<
    SearchDataProps[]
  >([])
  const [
    multiselectInputValueProcessOrder,
    setMultiselectInputValueProcessOrder,
  ] = React.useState<string[]>([])
  const [mapHeat, setMapHeat] = React.useState<SearchDataProps[]>([])
  const [mapProjects, setMapProjects] = React.useState<SearchDataProps[]>([])
  const [typeItems, setTypeItems] = React.useState<string[] | null>(null)
  const [typeInspectionItems, setTypeInspectionItems] = React.useState<
    string[] | null
  >(null)
  const [mapPedidoItem, setMapPedidoItem] = React.useState<SearchDataProps[]>(
    []
  )
  const [selectAllProcessOrder, setSelectAllProcessOrder] =
    React.useState(false)
  const mapType = addOptionAll(
    Object.values(InsterpectorTypeEnum).map((elem, index) => {
      return {
        key: index + 1,
        value: t(elem),
        label: t(elem),
      }
    })
  )
  const mapInsterpectorType = addOptionAll(
    Object.values(SampleTypeEnum).map((elem, index) => {
      return {
        key: index + 1,
        value: t(elem),
        label: t(elem),
      }
    })
  )
  const identification = ''

  // useEffect(() => {
  //   if (siteCode) {
  //     setMappedTestsFilter(
  //       TESTS.filter((s) => s.sites.includes(siteCode)).map((s) => ({
  //           key: s.id,
  //           value: s.id?.toString() || '',
  //           label: t('report.id.${s.id}'),
  //         })
  //       )
  //     )
  // }, [siteCode])
  useEffect(() => {
    if (siteCode) {
      setMappedTestsFilter(
        TESTS.filter((s) => s.sites.includes(siteCode))
          .map((s) => ({
            key: s.key,
            value: s.id?.toString() || '',
            label: t(`report.id.${s.id}`),
          }))
          .sort((a, b) => a.label.localeCompare(b.label))
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [siteCode])

  const simulateClick = () => {
    const event = new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window,
    })
    rowFocus?.current?.dispatchEvent(event)
  }

  const clearProcessOrder = () => {
    setMapProcessOrder([])
    if (!originApprovalFlow) setProcessOrderItems([])
    clearResults()
  }

  const findProjectsQp = async () => {
    try {
      setIsLoading(true)
      if (startDate && endDate && testSelected) {
        const result = await reportFilter({
          filterType: true,
          test: testSelected,
          filter: testSelected.type === 4 ? 'QP_CORROSIVE' : 'PROJECT',
          site: siteCode,
          start: moment(startDate).startOf('day').format('YYYY/MM/DD HH:mm:ss'),
          end: moment(endDate).endOf('day').format('YYYY/MM/DD HH:mm:ss'),
        })

        if (testSelected.type === 4) {
          const listItems = result?.list?.map(
            (s: { lot_id: any; ordem_de_processo: any }, index: number) => ({
              key: index + 1,
              value: s.lot_id || s.ordem_de_processo || '',
              label: s.lot_id || s.ordem_de_processo,
            })
          )
          setMapPqLot(listItems)
          if (identificationApprovalFlow) {
            setPqLotItems(
              Array.isArray(dataState.filter_header.pqLot)
                ? dataState.filter_header.pqLot
                : [dataState.filter_header.pqLot]
            )
            setPqLotItemsApprovalFlow(undefined)
            search()
          }
        } else {
          const listPorjects = addOptionAll(
            result?.list?.map((s: { desc_projeto: string }, index: number) => ({
              key: index + 1,
              value: s.desc_projeto || '',
              label: s.desc_projeto,
            }))
          )
          setMapProjects(listPorjects)
          if (identificationApprovalFlow) {
            setLabelProject(
              listPorjects.find(
                (s) =>
                  s.value ===
                  (dataState.filter_header.project ??
                    dataState.filter_header.projectChange)
              )?.label
            )
            setProject(
              listPorjects.find(
                (s) => s.value === dataState.filter_header.project
              )?.value
            )
          }
        }
      } else if (identificationApprovalFlow) {
        setIsLoading(false)
      }
    } catch (error: unknown) {
      if (isAxiosError(error)) {
        toast({
          title: 'Error',
          description: error.response?.data?.errorMessage ?? error.message,
          type: 'error',
        })
      }
    } finally {
      if (!identificationApprovalFlow) setIsLoading(false)
    }
  }

  const clearTest = (value: string) => {
    setTest('')
    value && setSiteCode(SITES.find((s) => s.name === value)?.code ?? '')
    // clearDate()
    clearResults()
  }

  const clearDate = () => {
    setStartDate(undefined)
    setEndDate(undefined)
    clearProject()
    clearPQ()
    clearResults()
  }

  const clearOrderItem = () => {
    setOrderItem('')
    setOrderItemFilter(undefined)
    clearProcessOrder()
  }

  const clearProject = () => {
    setProject('')
    setLabelProject('')
    setMapProjects([])
    clearPedidoItem()
    clearResults()
  }

  const clearPQ = () => {
    setMapPqLot([])
    if (!originApprovalFlow) setPqLotItems(null)
    clearResults()
  }

  const clearHeat = () => {
    setMapHeat([])
    setHeatItems(undefined)
    clearResults()
  }

  const changeTypeInspection = (value: string[]) => {
    setTypeInspectionItems(value.length > 0 ? value : null)
  }

  const changeType = (value: string[]) => {
    setTypeItems(value.length > 0 ? value : null)
  }

  useEffect(() => {
    if (!startDate && !endDate && !site && !test && testSelected?.type === 4) {
      findProjectsQp()
    } else if (orderItem && testSelected?.type !== 4) {
      findProcessOrder()
    }
  }, [typeInspectionItems, typeItems])

  const changePQ = (value: string[]) => {
    setPqLotItems(value.length > 0 ? value : null)
  }

  const changeProcessOrder = (value: string[]) => {
    setProcessOrderItems(value.length > 0 ? value : undefined)
    clearResults()
  }

  const changeHeat = (value: string[]) => {
    setHeatItems(value.length > 0 ? value : undefined)
  }

  const clearPedidoItem = () => {
    setMapPedidoItem([])
    setOrderItem('')
    setOrderItemFilter(undefined)
    clearOrderItem()
    clearHeat()
  }

  const search = async () => {
    try {
      setIsLoading(true)
      await executeQuery()
    } catch (error) {
      console.log('error', error)
    } finally {
      setIsLoading(false)
    }
  }

  const validate = () => {
    let valid = true
    if (!testSelected) {
      if (!identificationApprovalFlow) {
        toast({
          title: 'Error',
          description: t('generateReport.filterSection.required_filter'),
          type: 'error',
        })
      }
      valid = false
    } else {
      if (
        (!identification || identification.trim().length === 0) &&
        (!startDate ||
          !endDate ||
          !site ||
          !test ||
          !project ||
          !orderItem ||
          ((!processOrderItems || processOrderItems?.length < 1) &&
            (!heatItems || heatItems?.length < 1))) &&
        testSelected.type !== 4
      ) {
        toast({
          title: 'Error',
          description: t('generateReport.filterSection.required_filter'),
          type: 'error',
        })
        valid = false
      }
      if (
        (!identification || identification.trim().length === 0) &&
        (!startDate ||
          !endDate ||
          !site ||
          !test ||
          !pqLotItems ||
          pqLotItems.length === 0) &&
        testSelected.type === 4
      ) {
        toast({
          title: 'Error',
          description: t('generateReport.filterSection.required_filter_pq'),
          type: 'error',
        })
        valid = false
      }
    }
    if (!user || !user.userPosition) {
      toast({
        title: 'Error',
        description: t('user.not_position'),
        type: 'error',
      })
      valid = false
    }
    return valid
  }

  const executeQuery = async () => {
    if (validate() && testSelected && user && user.userPosition) {
      try {
        setIsLoading(true)

        const result = await documentSearch({
          email: user.email,
          find: true,
          heat: heatItems,
          id_sample: [],
          inspectorType: getTypeInspectionItems(),
          orderItem: orderItemFilter,
          orderProcess:
            processOrderItems && processOrderItems.length > 0
              ? processOrderItems
              : null,
          position: user.userPosition,
          pqLot: pqLotItems,
          project,
          sampleType: getSampleType(),
          site: siteCode,
          test: testSelected,
          user: user.userName,
          start: moment(startDate).startOf('day').format('YYYY/MM/DD HH:mm:ss'),
          end: moment(endDate).endOf('day').format('YYYY/MM/DD HH:mm:ss'),
        })

        const template = generateObject(testSelected.code)
        setTemplateTest(template)

        // getDataAv(data) {
        //   if (data['dmeim']) {
        //       return data['dmeim'];
        //   } else if (data['durezahv']) {
        //       return data['durezahv'];
        //   } else if (data['durezahb']) {
        //       return data['durezahb'];
        //   } else if (data['durezhrb']) {
        //       return data['durezhrb'];
        //   } else if (data['durezhrc']) {
        //       return data['durezhrc'];
        //   } else if (data['durhv10']) {
        //       return data['durhv10'];
        //   }
        //   return '';
        // }

        const res: { columns: DataResultTemplate[]; row: any[] } = {
          columns: [],
          row: [],
        }
        if (template) {
          res.columns = template.map((elem) => {
            return {
              id: elem.id,
              accessorKey: elem.id,
              header: t(elem.header),
              width: elem.width,
              cell: ({ cell }) => {
                return <div>{cell.getValue()}</div>
              },
            } as DataResultTemplate
          })
          const lengthItems = result.list.length
          res.row = result.list.map((item: any, index: number) => {
            item.checked =
              (item.document_version === undefined &&
                testSelected?.typeCode !== 'collapse') ||
              (item.document_version === undefined && lengthItems === 1)
            const objectRow = {
              ...Object.entries(item).reduce((acc, [key, value]) => {
                if (value) {
                  let valueDiv = value
                  let newKey = key
                  if (testSelected.code === 'test.hardness') {
                    if (
                      key === 'dmeim' ||
                      key === 'durezahv' ||
                      key === 'durezahb' ||
                      key === 'durezhrb' ||
                      key === 'durezhrc' ||
                      key === 'durhv10'
                    ) {
                      newKey = 'dmeim'
                    }
                  }
                  if (
                    testSelected.code === 'test.nace.d' &&
                    key === 'id_ensaio'
                  ) {
                    valueDiv = `${value} - ${item.n_cp}`
                  }
                  if (
                    testSelected.code === 'test.chemical' &&
                    key === 'analysis'
                  ) {
                    valueDiv =
                      value === 'AM_ANQC1'
                        ? 'Check 1'
                        : value === 'AM_ANQC2'
                          ? 'Check 1'
                          : ''
                  }
                  acc[newKey] = (
                    <div style={{ whiteSpace: 'nowrap' }}>
                      {String(valueDiv)}
                    </div>
                  ) as React.ReactNode
                }
                return acc
              }, {}),
              index,
            }
            return objectRow
          })
        }
        setTemplateColumn(res.columns)
        setTemplateRow(res.row)
        setResultItems(result?.list)
      } catch (error) {
        console.log(error)
        if (isAxiosError(error)) {
          toast({
            title: 'Error',
            description: error.response?.data?.errorMessage ?? error.message,
            type: 'error',
          })
        } else {
          toast({
            title: 'Error',
            description: `${error}`,
            type: 'error',
          })
        }
      } finally {
        setIsLoading(false)
      }
    } else {
      setTemplateColumn([])
      setTemplateRow([])
    }
  }

  const getTypeInspectionItems = () => {
    const inspection: string[] = []
    if (typeInspectionItems && typeInspectionItems.length > 0) {
      if (typeInspectionItems.includes('***')) inspection.push('NO_DEF')
      if (
        typeInspectionItems.includes('Interno') ||
        typeInspectionItems.includes('Internal')
      )
        inspection.push('I')
      if (
        typeInspectionItems.includes('Terceiro') ||
        typeInspectionItems.includes('Third')
      )
        inspection.push('T')
    }
    return inspection.length > 0 ? inspection : null
  }

  const getSampleType = () => {
    const sample = []
    if (typeItems && typeItems.length > 0) {
      if (typeItems.includes('***')) return null

      if (typeItems.includes('Produção') || typeItems.includes('Production'))
        sample.push('PRODUCTION')
      if (typeItems.includes('MPQT')) sample.push('MPQT')
      if (typeItems.includes('FDPT')) sample.push('FDPT')
      if (typeItems.includes('PD') || typeItems.includes('P&D'))
        sample.push('PD')
    }
    return sample.length > 0 ? sample : null
  }

  const findProcessOrder = async () => {
    try {
      setIsLoading(true)
      if (testSelected && orderItem) {
        let orderItemSplit = orderItem.split('/')
        const pedidoItem = mapPedidoItem.find((p) => {
          const pedidoItemArray = p.label.split('/')
          return (
            pedidoItemArray[0] == orderItemSplit[0] &&
            pedidoItemArray[1] == orderItemSplit[1]
          )
        })

        if (pedidoItem?.value) {
          orderItemSplit = pedidoItem.value.split('/')
          const orderItemFind = {
            pedido: orderItemSplit[0],
            item: orderItemSplit[1],
          }
          setOrderItemFilter(orderItemFind)

          const result = await reportFilter({
            filterType: true,
            test: testSelected,
            filter: 'PROCESS_ORDER',
            start: moment(startDate)
              .startOf('day')
              .format('YYYY/MM/DD HH:mm:ss'),
            end: moment(endDate).endOf('day').format('YYYY/MM/DD HH:mm:ss'),
            project,
            site: siteCode,
            orderItem: orderItemFind,
            type: testSelected?.type,
            inspectorType: getTypeInspectionItems(),
            sampleType: getSampleType(),
          })
          if (testSelected.type === 5) {
            setMapHeat(
              result?.list?.map((s: { corrida: string }, index: number) => ({
                key: index + 1,
                value: s.corrida,
                label: s.corrida,
              }))
            )
          } else {
            const listItems = result?.list?.map(
              (s: { lot_id: any; ordem_de_processo: any }, index: number) => ({
                key: index + 2,
                value: s.lot_id || s.ordem_de_processo || '',
                label: s.lot_id || s.ordem_de_processo,
              })
            )

            setMapProcessOrder(
              listItems
                ? addOptionAll(listItems, 1, t('application.selectAll'))
                : []
            )
            if (identificationApprovalFlow) {
              setProcessOrderItems(dataState.filter_header.orderProcess)
              setProcessOrderItemsApprovalFlow(undefined)
              search()
            }
          }
        }
      } else if (identificationApprovalFlow) {
        setIsLoading(false)
      }
    } catch (error: unknown) {
      if (isAxiosError(error)) {
        toast({
          title: 'Error',
          description: error.response?.data?.errorMessage ?? error.message,
          type: 'error',
        })
      }
    } finally {
      if (!identificationApprovalFlow) setIsLoading(false)
    }
  }

  const findOrderItem = async () => {
    try {
      setIsLoading(true)
      if (testSelected) {
        const result = await reportFilter({
          filterType: true,
          test: testSelected,
          filter: 'ORDER_ITEM',
          start: moment(startDate).startOf('day').format('YYYY/MM/DD HH:mm:ss'),
          end: moment(endDate).endOf('day').format('YYYY/MM/DD HH:mm:ss'),
          project,
          site: siteCode,
          orderItem: orderItemFilter,
          type: testSelected?.type,
        })
        if (testSelected.type === 5) {
          // heatItems = result.list;
          setMapPedidoItem(
            result?.list?.map(
              (s: { item: any; pedido: any }, index: number) => {
                const pedido =
                  s.pedido && s.pedido.trim() !== '' ? s.pedido.trim() : ''
                const item =
                  s.item && s.item.trim() !== '' ? Number(s.item) : ''
                return {
                  key: index + 1,
                  value: `${s.pedido}/${s.item}`,
                  label: `${pedido}/${item}`,
                }
              }
            )
          )
        } else {
          const listItems = result?.list?.map(
            (s: { item: any; pedido: any }, index: number) => {
              const pedido =
                s.pedido && s.pedido.trim() !== '' ? s.pedido.trim() : ''
              const item = s.item && s.item.trim() !== '' ? Number(s.item) : ''
              return {
                key: index + 1,
                value: `${s.pedido}/${s.item}`,
                label: `${pedido}/${item}`,
              }
            }
          )
          setMapPedidoItem(listItems)
          if (identificationApprovalFlow) {
            if (dataState.filter_header.orderItemChange) {
              setOrderItem(`${dataState.filter_header.orderItemChange.trim()}`)
            } else {
              setOrderItem(
                `${dataState.filter_header.pedido ? String(dataState.filter_header.pedido).trim().replace(/^0+/, '') : ''}/${dataState.filter_header.item ?? ''}`
              )
            }
          }
        }
      } else if (identificationApprovalFlow) {
        setIsLoading(false)
      }
    } catch (error: unknown) {
      if (isAxiosError(error)) {
        toast({
          title: 'Error',
          description: error.response?.data?.errorMessage ?? error.message,
          type: 'error',
        })
      }
    } finally {
      if (!identificationApprovalFlow) setIsLoading(false)
    }
  }

  const changeTest = (value: string) => {
    setTest(value)
    clearDate()
  }

  const clearResults = () => {
    setTemplateColumn([])
    setTemplateRow([])
    setResultItems([])
    setClientHeader('')
    setDescriptionHeader('')
    setProjectHeader('')
    setInspectionHeader('')
    setPedidoItemHeader('')
    setRemark1('')
    setRemark2('')
    setRemark3('')
  }

  useEffect(() => {
    let clearFilter = true
    clearResults()
    if (startDate && endDate && testSelected) {
      if (moment(endDate).diff(moment(startDate), 'days') >= 90) {
        toast({
          title: 'Error',
          description: t('generateReport.filterSection.period_max'),
          type: 'error',
        })
      } else {
        findProjectsQp()
        clearFilter = false
      }
    }

    if (clearFilter) {
      clearPQ()
      clearProject()
      clearProcessOrder()
      clearHeat()
    }
  }, [startDate, endDate, testSelected])

  useEffect(() => {
    if (project) {
      findOrderItem()
    } else {
      clearPedidoItem()
    }
  }, [project])

  useEffect(() => {
    if (orderItem) {
      findProcessOrder()
    } else {
      clearPQ()
    }
  }, [orderItem])

  useEffect(() => {
    setTestSelected(
      TESTS.find((elem) => elem.name === test || elem.namePt === test)
    )
  }, [test])

  useEffect(() => {
    if (executeSearch) {
      search()
      setExecuteSearch(false)
    }
  }, [executeSearch])

  useEffect(() => {
    if (identificationApprovalFlow && originApprovalFlow) {
      search()
    }
  }, [pqLotItems])

  useEffect(() => {
    clearResults()
    if (originApprovalFlow && dataState?.docCode) {
      setIdentificationApprovalFlow(dataState.docCode)
      setSite(SITES.find((s) => s.code === dataState.site)?.name ?? '')
      setSiteCode(dataState.site)
      setTest(
        TESTS.find(
          (s) =>
            s.name === dataState.test_name || s.namePt === dataState.test_name
        )?.name ?? ''
      )

      setStartDate(new Date(dataState.filter_header.startDate))
      setStartDateApprovalFlow(undefined)
      setEndDate(new Date(dataState.filter_header.endDate))
      setEndDateApprovalFlow(undefined)
      setProcessOrderItems(dataState.filter_header.orderProcess)
      setPqLotItems(dataState.filter_header.pqLot)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleMultiselectChange = (value: string[]) => {
    setMapProcessOrder((prevMap) => {
      setMultiselectInputValueProcessOrder((prevMultiselect) => {
        setSelectAllProcessOrder((prevSelectAll) => {
          if (value.includes(t('application.selectAll')) && !prevSelectAll) {
            prevMap[0].label = t('application.deselectAll')
            changeProcessOrder(prevMap.map((item) => item.value) as string[])
            return true
          }
          if (prevMap[0].label === t('application.deselectAll')) {
            prevMap[0].label = t('application.selectAll')
          }

          changeProcessOrder(
            prevSelectAll &&
              prevMultiselect.includes('NO_DEF') &&
              value.includes(t('application.deselectAll'))
              ? []
              : value
          )
          return false
        })
        return prevMultiselect
      })
      return prevMap
    })
  }

  useEffect(() => {
    setMultiselectInputValueProcessOrder(
      processOrderItemsApprovalFlow ?? processOrderItems ?? []
    )
  }, [processOrderItemsApprovalFlow, processOrderItems])

  return (
    <Section.Root
      header={
        <Section.Header
          title={t<string>('generateReport.filterSection.title')}
          isCollapsable
          actionButtons={
            <ButtonContainer width="8rem">
              <StyledButton onClick={() => search()}>
                <StyledTextButton>
                  <Icon name="SearchLine" color="white" />
                  {t<string>('generateReport.filterSection.search')}
                </StyledTextButton>
              </StyledButton>
            </ButtonContainer>
          }
        />
      }
    >
      <Row>
        <SearchBarContainer>
          <StyledInputLabel>
            {t('generateReport.filterSection.site')}
          </StyledInputLabel>
          <SearchBar
            type="text"
            data={mappedSites}
            placeholder={t('generateReport.filterSection.site')}
            iconColor="neutral-color-60"
            onChange={(value) => {
              setSite(value)
              clearTest(value)
            }}
            inputValue={site}
          />
        </SearchBarContainer>
        <SearchBarContainer>
          <StyledInputLabel>
            {t('generateReport.filterSection.test')}
          </StyledInputLabel>
          <ExpandedOptionsWrapper>
            <SearchBar
              type="text"
              data={mappedTestsFilter}
              placeholder={t('generateReport.filterSection.test')}
              iconColor="neutral-color-60"
              onChange={(value) => {
                changeTest(value)
              }}
              inputValue={test}
            />
          </ExpandedOptionsWrapper>
        </SearchBarContainer>
        <SearchBarContainer ref={rowFocus}>
          <DatePicker.Root>
            <DatePicker.Trigger
              label={t<string>('generateReport.filterSection.startDate')}
              value={
                startDateApprovalFlow
                  ? new Date(startDateApprovalFlow)
                  : startDate
                    ? new Date(startDate)
                    : undefined
              }
            />
            <DatePicker.SingleDayPicker
              closeOnSelect
              onDaySelect={({ selected }) => selected && setStartDate(selected)}
            />
          </DatePicker.Root>
        </SearchBarContainer>
        <SearchBarContainer>
          <DatePicker.Root>
            <DatePicker.Trigger
              label={t<string>('generateReport.filterSection.endDate')}
              value={
                endDateApprovalFlow
                  ? new Date(endDateApprovalFlow)
                  : endDate
                    ? new Date(endDate)
                    : undefined
              }
            />
            <DatePicker.SingleDayPicker
              closeOnSelect
              onDaySelect={({ selected }) =>
                selected && setEndDate(new Date(selected))
              }
            />
          </DatePicker.Root>
        </SearchBarContainer>
        {testSelected?.type !== 4 && testSelected?.name !== 'mpi' && (
          <SearchBarContainer>
            <StyledInputLabel>
              {t('generateReport.filterSection.project')}
            </StyledInputLabel>
            <SearchBar
              type="text"
              data={mapProjects}
              placeholder={t('generateReport.filterSection.project')}
              iconColor="neutral-color-60"
              onChange={(value) => {
                setLabelProject(value)
                setProject(value ? (value !== '***' ? value : 'NO_DEF') : '')
              }}
              inputValue={labelProject}
            />
          </SearchBarContainer>
        )}
        {testSelected?.type !== 4 && testSelected?.name !== 'mpi' && (
          <SearchBarContainer>
            <StyledInputLabel>
              {t('generateReport.filterSection.orderItem')}
            </StyledInputLabel>
            <SearchBar
              type="text"
              data={mapPedidoItem}
              placeholder={t('generateReport.filterSection.orderItem')}
              iconColor="neutral-color-60"
              onChange={(value) => setOrderItem(value)}
              inputValue={orderItem}
            />
          </SearchBarContainer>
        )}
        {testSelected?.type !== 4 && testSelected?.name !== 'mpi' && (
          <SearchBarContainer>
            <StyledInputLabel>
              {t('generateReport.filterSection.typeInspection')}
            </StyledInputLabel>
            <SearchBar
              type="text"
              data={mapType}
              placeholder={t('generateReport.filterSection.typeInspection')}
              iconColor="neutral-color-60"
              onMultiselectChange={(value) => changeTypeInspection(value)}
              inputValue=""
              multiselect
              multiselectInputValue={typeInspectionItems ?? []}
            />
          </SearchBarContainer>
        )}
        {testSelected?.type !== 4 && testSelected?.name !== 'mpi' && (
          <SearchBarContainer>
            <StyledInputLabel>
              {t('generateReport.filterSection.type')}
            </StyledInputLabel>
            <SearchBar
              type="text"
              data={mapInsterpectorType}
              placeholder={t('generateReport.filterSection.type')}
              iconColor="neutral-color-60"
              onMultiselectChange={(value) => changeType(value)}
              inputValue=""
              multiselect
              multiselectInputValue={typeItems ?? []}
            />
          </SearchBarContainer>
        )}
        {testSelected?.type === 4 && testSelected?.name !== 'mpi' && (
          <SearchBarContainer>
            <StyledInputLabel>
              {t('generateReport.filterSection.pqLot')}
            </StyledInputLabel>
            <SearchBar
              type="text"
              data={mapPqLot}
              placeholder={t('generateReport.filterSection.pqLot')}
              iconColor="neutral-color-60"
              onMultiselectChange={(value) => changePQ(value)}
              inputValue=""
              multiselect
              multiselectInputValue={pqLotItems ?? []}
            />
          </SearchBarContainer>
        )}
        {testSelected?.type !== 5 &&
          testSelected?.type !== 4 &&
          testSelected?.name !== 'mpi' && (
            <SearchBarContainer>
              <StyledInputLabel>
                {t('generateReport.filterSection.processOrder')}
              </StyledInputLabel>
              <SearchBar
                type="text"
                data={mapProcessOrder}
                placeholder={t('generateReport.filterSection.processOrder')}
                iconColor="neutral-color-60"
                onMultiselectChange={handleMultiselectChange}
                inputValue=""
                multiselectInputValue={multiselectInputValueProcessOrder}
                multiselect
              />
            </SearchBarContainer>
          )}
        {testSelected?.type === 5 && testSelected?.name !== 'mpi' && (
          <SearchBarContainer>
            <StyledInputLabel>
              {t('generateReport.filterSection.heat')}
            </StyledInputLabel>
            <SearchBar
              type="text"
              data={mapHeat}
              placeholder={t('generateReport.filterSection.heat')}
              iconColor="neutral-color-60"
              onMultiselectChange={(value) => changeHeat(value)}
              inputValue=""
              multiselect
            />
          </SearchBarContainer>
        )}
        {identificationApprovalFlow && (
          <SearchBarContainer>
            <StyledInputLabel>
              {t('generateReport.filterSection.identification')}
            </StyledInputLabel>
            <TextFieldInput
              fontSize="text-md"
              name="actionNameInput"
              disabled
              onChange={(event) => console.log(event?.target?.value)}
              placeholder={t(
                '',
                t('searchReport.filterSection.identification')
              )}
              width="100%"
              value={identificationApprovalFlow}
            />
          </SearchBarContainer>
        )}
      </Row>
    </Section.Root>
  )
}

export default FilterSection
